import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import * as phoneNumbersClient from 'ContentData/api/PhoneNumbers';
import { WHATSAPP_PHONE_NUMBERS_FETCH } from 'ContentData/actions/ActionTypes';
export const fetchWhatsappNumbers = createGenericFetchAction(WHATSAPP_PHONE_NUMBERS_FETCH, phoneNumbersClient.getWhatsAppNumbers);